import AdvertsContainer from 'modules/adverts/containers/AdvertsContainer';

const AdvertsView = props => <AdvertsContainer {...props} />;

export default AdvertsView;
